import { render, staticRenderFns } from "./FieldAreaSelector.vue?vue&type=template&id=05dcff23"
import script from "./FieldAreaSelector.vue?vue&type=script&lang=js"
export * from "./FieldAreaSelector.vue?vue&type=script&lang=js"
import "./FieldAreaSelector.vue?vue&type=style&index=0&id=05dcff23&prod&lang=scss"
/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports